export default "__VITE_ASSET__mIrOmZX$EjcQAaU9wsxwng__"